import { useEffect } from 'react'
import type { RestaurantId } from '~/lib/graphql/scalars'

// クライアントナビゲーションでも発火するように明示的に叩く
export function RequestBeacon({ restaurantId }: { restaurantId: RestaurantId }) {
  useEffect(() => {
    fetch(`/${restaurantId}/beacon`)
  }, [restaurantId])
  return null
}
